import React, { useContext, useEffect, useState } from 'react';
import { firebaseAuth } from '../../providers/AuthProvider';
import firebase from 'firebase/compat/app';
import ReportTable from './ReportTable';
import { formatCustomerCareDate } from './customerCareDashboard';

const columns = [
  { key: 'createdAt', label: 'Date sent', value: (row) => formatCustomerCareDate(row.createdAt), sortValue: (row) => row.createdAt?.seconds || 0 },
  { key: 'dataType', label: 'Data type', value: (row) => row.dataType || '' },
  { key: 'eventName', label: 'Event', value: (row) => row.eventName || '' },
  { key: 'campaignCode', label: 'Campaign code', value: (row) => row.campaignCode || '' },
  { key: 'campaignDescription', label: 'Campaign description', value: (row) => row.campaignDescription || '' },
  { key: 'filename', label: 'Filename', value: (row) => row.filename || '' },
  { key: 'records', label: 'Records', value: (row) => row.records || '', sortValue: (row) => Number(row.records) || 0 },
  { key: 'sftpSuccess', label: 'Delivery', value: (row) => row.sftpSuccess || '' },
];
const filters = [
  { key: 'dataType', label: 'Data type', options: [['LEAD', 'Lead'], ['IH', 'Interaction History']], value: (row) => row.dataType || '' },
  { key: 'delivery', label: 'Delivery', options: [['Yes', 'Successful'], ['No', 'Failed'], ['N/A', 'Not sent']], value: (row) => row.sftpSuccess || '' },
];

export default function LeadActivity() {
  const { user } = useContext(firebaseAuth);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    firebase.functions().httpsCallable('appV2/listLeadActivity')({})
      .then((result) => setRows(result.data || []))
      .catch(() => setRows([])).finally(() => setLoading(false));
  }, []);
  return <ReportTable title="Lead Activity" rows={rows} loading={loading} columns={columns}
    filters={filters} dateKey="createdAt" storageKey="leadActivityTable:v1"
    exportName="lead-activity" canExport={Number(user?.role) === 1 || user?.crmManager === true} />;
}
